import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypeQuickStartResourceFields {
  heading: EntryFieldTypes.Symbol
  label: EntryFieldTypes.Symbol<
    | 'Driving Tests and Reports'
    | 'Exciting Writing Ideas'
    | 'Fast Phonics'
    | 'Lessons'
    | 'Library, Journal and Read Aloud Fluency'
    | 'Long Writes'
    | 'Mathseeds Prime'
    | 'Mental Minute'
    | 'Placement Test'
    | 'Reading Eggs'
    | 'Reading Eggspress 2-6'
    | 'Reports, Lexile Growth and Certificates'
    | 'Spelling Lessons'
    | 'Writing Lessons'
  >
  body: EntryFieldTypes.Text
  bullets?: EntryFieldTypes.Array<EntryFieldTypes.Symbol>
  video?: EntryFieldTypes.AssetLink
  pdf?: EntryFieldTypes.AssetLink
  product: EntryFieldTypes.Symbol<'fp' | 'ms' | 'mx' | 're' | 'wl' | 'rex'>
}

export type TypeQuickStartResourceSkeleton = EntrySkeletonType<TypeQuickStartResourceFields, 'quickStartResource'>
export type TypeQuickStartResource<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeQuickStartResourceSkeleton,
  Modifiers,
  Locales
>

export function isTypeQuickStartResource<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeQuickStartResource<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'quickStartResource'
}

export type TypeQuickStartResourceWithoutLinkResolutionResponse = TypeQuickStartResource<'WITHOUT_LINK_RESOLUTION'>
export type TypeQuickStartResourceWithoutUnresolvableLinksResponse =
  TypeQuickStartResource<'WITHOUT_UNRESOLVABLE_LINKS'>
export type TypeQuickStartResourceWithAllLocalesResponse<Locales extends LocaleCode = LocaleCode> =
  TypeQuickStartResource<'WITH_ALL_LOCALES', Locales>
export type TypeQuickStartResourceWithAllLocalesAndWithoutLinkResolutionResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeQuickStartResource<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>
export type TypeQuickStartResourceWithAllLocalesAndWithoutUnresolvableLinksResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeQuickStartResource<'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES', Locales>
